import React from 'react';
import { Store, Warehouse } from 'lucide-react';

const StockInvoiceDestinationBar = ({
  magasinsList,
  magasinId,
  onMagasinChange,
  location,
  onLocationChange,
  compact = false,
}) => {
  const depotDisabled = magasinId !== 'M1';

  React.useEffect(() => {
    if (depotDisabled && location === 'depot') {
      onLocationChange('boutique');
    }
  }, [depotDisabled, location, onLocationChange]);

  return (
    <div
      className={`rounded-xl border border-white/10 bg-[#151820] ${compact ? 'p-3' : 'p-4'} space-y-3`}
      data-testid="invoice-destination-bar"
    >
      <p className="text-xs font-bold text-gray-400 uppercase tracking-wide">Destination du stock</p>
      <div className="flex flex-wrap gap-3 items-center">
        <span className="text-xs text-gray-500 shrink-0">Magasin</span>
        {magasinsList.length ? (
          magasinsList.map((m) => (
            <button
              key={m.code}
              type="button"
              onClick={() => onMagasinChange(m.code)}
              className={`px-3 py-2 min-h-[40px] rounded-lg text-xs font-bold border transition-colors ${
                magasinId === m.code
                  ? 'border-red-500/50 bg-red-950/30 text-white'
                  : 'border-white/10 text-gray-400 hover:border-white/20'
              }`}
              data-testid={`invoice-magasin-${m.code}`}
              title={m.name}
            >
              {m.code}
            </button>
          ))
        ) : (
          <select
            value={magasinId}
            onChange={(e) => onMagasinChange(e.target.value)}
            className="px-3 py-2 rounded-lg bg-black/30 border border-white/10 text-white text-sm min-h-[40px]"
            data-testid="invoice-magasin-select"
          >
            <option value="M1">M1</option>
            <option value="M2">M2</option>
          </select>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => onLocationChange('boutique')}
          className={`flex-1 min-w-[140px] min-h-[44px] px-4 rounded-lg border text-sm font-semibold flex items-center justify-center gap-2 transition-colors ${
            location === 'boutique'
              ? 'border-emerald-500/50 bg-emerald-950/30 text-emerald-300'
              : 'border-white/10 text-gray-400 hover:border-white/20'
          }`}
          data-testid="invoice-location-boutique"
        >
          <Store className="w-4 h-4" /> Boutique
        </button>
        <button
          type="button"
          onClick={() => !depotDisabled && onLocationChange('depot')}
          disabled={depotDisabled}
          className={`flex-1 min-w-[140px] min-h-[44px] px-4 rounded-lg border text-sm font-semibold flex items-center justify-center gap-2 transition-colors ${
            location === 'depot'
              ? 'border-blue-500/50 bg-blue-950/30 text-blue-300'
              : 'border-white/10 text-gray-400 hover:border-white/20'
          } ${depotDisabled ? 'opacity-40 cursor-not-allowed' : ''}`}
          data-testid="invoice-location-depot"
          title={depotDisabled ? 'Dépôt disponible uniquement sur M1' : 'Dépôt'}
        >
          <Warehouse className="w-4 h-4" /> Dépôt
        </button>
      </div>
      {depotDisabled && (
        <p className="text-[10px] text-gray-600">Le dépôt central est réservé au magasin M1.</p>
      )}
      <p className="text-[10px] text-gray-500">
        Import → <strong className="text-gray-300">{magasinId || '—'}</strong>
        {' · '}
        <strong className="text-gray-300">{location === 'depot' ? 'Dépôt' : 'Boutique'}</strong>
      </p>
    </div>
  );
};

export default StockInvoiceDestinationBar;
